import { render, staticRenderFns } from "./FormLogo.vue?vue&type=template&id=6a94b6af&"
import script from "./FormLogo.vue?vue&type=script&lang=ts&"
export * from "./FormLogo.vue?vue&type=script&lang=ts&"
import style0 from "./FormLogo.vue?vue&type=style&index=0&id=6a94b6af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports